import { ThreadListPrimitive } from '@assistant-ui/react';
import { Divider, Stack } from '@mantine/core';

import { ReportIssue } from './ReportIssue.tsx';
import classes from './ThreadList.module.css';
import { ThreadListItem } from './ThreadListItem.tsx';
import { ThreadListNew } from './ThreadListNew.tsx';

/** Thread list sidebar showing all chat threads with a "New Thread" button at the top. */
export function ThreadList() {
  return (
    <ThreadListPrimitive.Root className={classes.threadList}>
      <Stack gap="xs" justify="space-between" p="sm">
        <ThreadListNew />
        <Stack gap="xs">
          <div className={classes.threadListItems}>
            <ThreadListPrimitive.Items>{ThreadListItem}</ThreadListPrimitive.Items>
          </div>
        </Stack>
        <div>
          <Divider mb="xs" />
          <ReportIssue />
        </div>
      </Stack>
    </ThreadListPrimitive.Root>
  );
}
